// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1130":"0effbbb8","4592":"bf6b0691","7081":"552d4cf9","9957":"577f932f"}[chunkId] + ".chunk.css";
};